import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import { isIOS } from 'react-device-detect';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 10,
    padding: 12,
    position: 'fixed',
    bottom: 0,
    width: '100%',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    color: '#ffffff',
    marginRight: 5,
    padding: 0,
  },
  img: {
    borderRadius: 4,
    height: 45,
    width: 45,
  },
  info: { padding: '0px 10px', verticalAlign: 'middle' },
  title: {
    color: '#ffffff',
    margin: 0,
    fontSize: 14,
  },
  description: {
    color: '#ffffff',
    margin: 0,
    fontSize: 12,
  },
}));

const AppAlert = () => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(true);

  const goToApp = () => {
    if (isIOS) return window.open('https://apps.apple.com/br/app/eduzz-neg%C3%B3cios-digitais/id1079845439', '_blank');

    return window.open('https://play.google.com/store/apps/details?id=com.eduzzmobile.mobile', '_blank');
  };

  if (!open) return null;
  return (
    <Hidden only={['xl', 'lg', 'md']}>
      <div className={classes.container}>
        <div className={classes.content}>
          <IconButton className={classes.button} onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
          <img src='/img/icon-orbita.jpg' alt='APP Órbita' className={classes.img} />
          <div className={classes.info}>
            <p className={classes.title}>Experimente o APP da Eduzz!</p>
            <p className={classes.description}>Seu negócio na palma da mão.</p>
          </div>
        </div>
        <Button color='secondary' variant='contained' onClick={goToApp}>
          Usar
        </Button>
      </div>
    </Hidden>
  );
};

export default AppAlert;
